import {MergeObjects} from './../core/library/objects';
import MediaSources from './media_sources';
import * as Projects from './projects';
import {parseUrlParams} from "../core/library/url";
import PushRegions from './regions';

const PROJECT = process.env.PROJECT || "";


let Config = {
    LOCALE: "ru",
    PROJECT_PREFIX: "test",
    RESIZER: false,
    // project config
    PROJECT: {
        // project name
        NAME: PROJECT,
        // project default layout
        LAYOUT: "default",
        // project api path
        API: `http://localhost:8086/api/backend`,
    },

    // oauth configuration
    OAUTH: {
        // url for oauth domain
        URL: `https://oauth.absatz.media`,
        // current project domain
        PROJECT_DOMAIN: `localhost:3000`,
        // current project url path
        PROJECT_PATH: `http://localhost:3000`,
        // path for oauth api
        API: `https://oauth.absatz.media/auth`,
        // path for oauth users
        OAUTH_USER_PATH: `https://oauth.absatz.media/users/`,
        // prefix for authorization tokens
        PREFIX: 'oauth_',
    },
    // default date format
    DATE_FORMAT: "DD-MM-YYYY HH:mm",
    // configuration for slug plugin
    SLUG: {
        delimiter: '-',
        prefix: ''
    },

    // configuration for media
    MEDIA: {
        // path for cdn content
        CDN: {
            IMAGES: "https://cdni.rbth.com/rbthmedia/images",
            VIDEO: "https://cdni.rbth.com/rbthmedia/video"
        },
        // available copyright sources
        SOURCES: MediaSources,
        // available upload types
        UPLOAD_AVAILABLE: ['jpg', 'gif', 'png', 'jpeg', 'mp4', 'mp3'],
        // available embedded sources
        EMBEDDED_SOURCES: ['youtube.com', 'facebook.com', 'youtu.be'],
        EMEDDED_PREPARE: {
            'youtu.be': (path) => {
                let params = path.split('/');
                return (
                    `<iframe width="560" height="315" src="https://www.youtube.com/embed/${params[params.length - 1]}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
                );
            },
            'youtube.com': (path) => {
                let p = parseUrlParams(path);
                if (!p.v) return ``;
                return (
                    `<iframe width="560" height="315" src="https://www.youtube.com/embed/${p.v}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
                );
            },
            'facebook.com': (url) => {
                return (
                    `<iframe src="https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&width=500&show_text=false&appId=526970354336335&height=280" width="500" height="280" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media" allowFullScreen="true"></iframe>`
                )
            },
        },
    },

    DOCUMENTS: {
        STATUS: ["published", "unpublished", "prepublished_status"],
        MOVE_TYPES: ['Films', "Serials", "Episodes", "Arteldoc"],
    },
    EDITOR: {
        KEY: "clzzivqs4p1bb1eoei67nmbzwwzio5uv0w69ew52cc8ex5s7",
        SETTINGS: {
            language: 'ru',
        },
    },
    MAPS: {
        KEY: "e70f3b03-0677-45b8-911f-830daf383e37",
    },
    ELASTIC: {
        API: "http://localhost:8009/elastic"
    },
    MEDIA_DATABASE_TYPES: ['Image', 'Video', 'ExternalVideo', 'Code'],
    MEDIA_AVAILABLE_TYPES: '.jpg,.gif,.png,.jpeg,.mp4,.mp3',
    MEDIA_AVAILABLE_SOURCES: ['youtube', 'vimeo', 'facebook'],
    WIDGETS: {
        TYPES: ['Article', 'News', 'Episode', 'Infographic', 'Meaning', 'Trend', 'Banner', 'Show', 'Polls', 'Receipt']
    },
    REGIONS: PushRegions,
    PHOTO_AUTHORS: [],
    SPECIAL_PROJECT_TYPES: ['Фотовыставка', 'Спец. репортаж', 'Выставка', 'Специальный материал'],
    CROPPER: {
        WIDTH: 1200,
        HEIGHT: 675,
    },
    DEFAULT_CROSSLINKS_TYPES: 'Films,Serials,Episodes,News,Stories,Stories_cards,Quiz'
};

if (Projects[PROJECT]) {
    Config = MergeObjects(Config, Projects[PROJECT]);
}

window.APP_CONFIG = {
    PROJECT: Config.PROJECT,
    MEDIA: Config.MEDIA,
};

export const GetImagePath = (args, size = '320_0_') => {
    let files = args.files || args;
    size = '320_0'

    if (!files || !files['original'] || !files['original'].path) {
        return '/images/nocover.png';
    }
    let path = files['original']['path'].split('/');
    if (Config.MEDIA.CDN.IMAGES.indexOf('cdn.') + 1 > 0) {
        path[path.length - 1] = `${size}_${path[path.length - 1]}`;
    }

    return `${Config.MEDIA.CDN.IMAGES}/${path.join('/')}`;
    // return `https://cdni.vm.ru/${path.join('/')}`;
}

const mediaPrefixMap = {
    "image": "images",
    "cover": "images",
    "video": "videos",
    "coverhorizontal": "images",
    "coververtical": "images",
    "coverhorizontalclean": "images",
    "coververticalclean": "images",
    "coversquare": "images",
    "coversquareclean": "images",
    "coverhorizontalen": "images",
    "coversquareen": "images",
    "coververticalen": "images",
}

export const GetMediaPrefix = (mediaType) => {
    return mediaPrefixMap[mediaType.toLowerCase()] || mediaType.toLowerCase();
}

const GWCdnMedia = 'https://cdn.arteldoc.com';

export const GetMediaPath = (media, size = 'original', width = 320) => {
    if (!media || !media.files) return null;
    let mediaSize = media.files[size] ? media.files[size] : media.files["original"];
    let prefix = GetMediaPrefix(media.type);
    let path = mediaSize.path;

    if (width > 0 && path) {
        let pathParams = path.split('/');
        pathParams[pathParams.length - 1] = `${width}_0_${pathParams[pathParams.length - 1]}`;
        path = pathParams.join('/');
    }

    return `${GWCdnMedia}/${prefix}/${path}`;
}

export const GetMediaCdnPath = (media) => {
    if (!media || !media.files || !media.files.original || !media.files.original.path) {
        return '';
    }

    const filePath = media.files.original.path;
    switch (media.type) {
        case 'VTT':
            return `https://cdn.arteldoc.com/vtt/${filePath}`;
        case 'VideoLangAudio':
            return `https://cdn.arteldoc.com/audio/${filePath}`;
        case 'Video':
            return `https://cdn.arteldoc.com/videos/${filePath}`;
        default:
            return '';
    }
}


export const ImageMediaTypes = [
    'Cover', 'Image', 'CoverHorizontal', 'CoverHorizontalCh', 'CoverHorizontalClean', 'CoverHorizontalEn', 'CoverSquare', 'CoverSquareCh', 'CoverSquareClean', 'CoverSquareEn', 'CoverVertical', 'CoverVerticalCh', 'CoverVerticalClean', 'CoverVerticalEn'
]

export const VideoMediaTypes = ['Video'];
export const AudioMediaTypes = ['VideoLangAudio'];
export const SubtitleMediaTypes = ['VTT'];
export const LanguageStorageKey = 'rtdoc_lng';


export const HubLanguagesMapping = {
    'en': 'en-US',
    'ru': 'ru-RU',
}

export const GenerateRedirectUrl = (doc) => {
    return `/mrg/${doc.publicId}`
}

export const GetMainImage = (media) => {
    let cover = media.filter(i => i.type === 'Cover');
    if (!cover || cover.length === 0) {
        let images = media.filter(i => ImageMediaTypes.indexOf(i.type) + 1 > 0);
        if (images.length > 0) {
            return images[0];
        }
    } else {
        return cover[0];
    }
    return null;
}


export const uuidv4 = () => {
    let d = new Date().getTime();//Timestamp
    let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

export default Config;


